import Splide from '@splidejs/splide';
import { initTestimonialSlider } from './testimonial-slider';

class Slider {
	currentIndex = 0;

	constructor(el) {
		if (el) {
			this.el = el;
			this.track = this.el.querySelector('.splide__track');
			this.slideCount = this.el.querySelectorAll('.splide__slide').length;
			this.splide = new Splide(this.el);
			this.slides = this.el.querySelectorAll('.splide__slide');
			this.arrowsEl = this.el.querySelector('.splide__arrows');
			this.options = JSON.parse(this.el.getAttribute('data-splide'));

			if (this.options.syncId) {
				this.syncedSplide = new Splide(`#${this.options.syncId}`, this.options.syncOptions || {});
				this.splide.sync(this.syncedSplide);
			}

			if (this.el.classList.contains('em-testimonial-slider__images')) {
				initTestimonialSlider(this);
			}

			this.splide.mount();

			if (this.syncedSplide) {
				this.syncedSplide.mount();
			}

			this.updateTrackHeight();
			window.addEventListener('resize', () => {
				window.requestAnimationFrame(() => {
					this.updateTrackHeight();
				});
			});

			this.maybeHideArrows();
			window.addEventListener('resize', this.maybeHideArrows);

			this.splide.on('move', this.beforeMove);
			this.splide.on('moved', this.afterMove);
		}
	}

	isVertical = () => this.splide._options.direction === 'ttb';

	getTallestSlideHeight = () => {
		let height = 0;
		this.slides.forEach((slide) => {
			if (slide.offsetHeight > height) {
				height = slide.offsetHeight;
			}
		});
		return height;
	};

	updateTrackHeight = () => {
		if (this.slides[this.currentIndex] && this.isVertical() && this.options.heightCssVar) {
			document.documentElement.style.setProperty(this.options.heightCssVar, `${this.slides[this.currentIndex].offsetHeight}px`);
		}
	}

	beforeMove = (newIndex, prevIndex) => {
		let enteringSlide;
		let leavingSlide;

		if (newIndex > prevIndex) {
			enteringSlide = this.el.querySelector('.splide__slide.is-next');
			leavingSlide = this.el.querySelector('.splide__slide.is-active');
		} else if (newIndex < prevIndex) {
			enteringSlide = this.el.querySelector('.splide__slide.is-prev');
			leavingSlide = this.el.querySelector('.splide__slide.is-active');
		}

		if (enteringSlide) {
			enteringSlide.classList.add('is-entering');
		}

		if (leavingSlide) {
			leavingSlide.classList.add('is-leaving');
		}

		this.currentIndex = newIndex;
		this.updateTrackHeight();
	}

	afterMove = () => {
		const slides = this.el.querySelectorAll('.is-entering, .is-leaving');
		if (slides.length) {
			slides.forEach((slide) => {
				slide.classList.remove('is-entering');
				slide.classList.remove('is-leaving');
			});
		}
	}

	maybeHideArrows = () => {
		window.requestAnimationFrame(() => {
			if (this.arrowsEl) {
				const splideData = this.el.getAttribute('data-splide');
				const parsedData = JSON.parse(splideData);
				if (parsedData && parsedData.breakpoints) {
					let breakpointKeys = Object.keys(parsedData.breakpoints);
					breakpointKeys = breakpointKeys.map((key) => parseInt(key));
					breakpointKeys = breakpointKeys.sort((a, b) => {
						if (a > b) return 1;
						if (a < b) return -1;
						return 0;
					});

					let currentBreakpoint = false;
					breakpointKeys.every((bp) => {
						if (bp >= window.innerWidth) {
							currentBreakpoint = bp;
							return false;
						}
						return true;
					});
					let bpPerPage = parsedData.perPage;
					if (currentBreakpoint) {
						bpPerPage = parsedData.breakpoints[currentBreakpoint].perPage;
					}
					if (bpPerPage && this.slideCount <= bpPerPage) {
						this.arrowsEl.style.display = 'none';
					} else {
						this.arrowsEl.style.display = '';
					}
				}
			}
		});
	}
}

const sliderEls = [...document.querySelectorAll('.splide[data-splide]')];
if (sliderEls.length) {
	embark.components.splides = sliderEls.map((el) => new Slider(el));
	window.dispatchEvent(
		new CustomEvent('em-slider-mounted', {
			bubbles: true,
			detail: { text: () => Date.now() },
		}),
	);
}
